var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Briefcase",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "briefcase",
    transform: "translate(2.500000, 3.000000)",
    stroke: "#000000",
    strokeWidth: 1.33333333
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 2.66666667,
    width: 13.3333333,
    height: 9.33333333,
    rx: 1.33333333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33333333,12 L9.33333333,1.33333333 C9.33333333,0.596953667 8.73637967,0 8,0 L5.33333333,0 C4.59695367,0 4,0.596953667 4,1.33333333 L4,12",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.c368e9205fa4318f477ae4d210f3dc88.svg";
export { ForwardRef as ReactComponent };